const types = {
  text: 'text',
  select: 'select',
  boardSelect: 'boardSelect',
  date: 'date',
  number: 'number',
};

export default types;
